const React = require('react');
const { gsap } = require('gsap');
const { Draggable } = require('gsap/Draggable');
const { InertiaPlugin } = require('gsap/InertiaPlugin');
const { linkResolver } = require('./src/utils/linkResolver');
const { IntlProvider } = require('react-intl');
const { registerLinkResolver } = require('gatsby-source-prismic-graphql');

const { UIProvider } = require('context/ui');

// Polyfill NumberFormat if `is` isn't supported
if (Intl.NumberFormat.supportedLocalesOf('is').length === 0) {
  const UnifiedNumberFormat = require('@formatjs/intl-unified-numberformat');
  UnifiedNumberFormat.UnifiedNumberFormat.__addLocaleData(
    require('@formatjs/intl-unified-numberformat/dist/locale-data/is.json')
  );

  UnifiedNumberFormat.UnifiedNumberFormat.__addLocaleData(
    require('@formatjs/intl-unified-numberformat/dist/locale-data/en.json')
  );

  delete Intl.NumberFormat;
  Intl.NumberFormat = UnifiedNumberFormat.UnifiedNumberFormat;
}

const en = require('./src/localization/en');
const is = require('./src/localization/is');

const messages = { 'en-us': en, is };

registerLinkResolver(linkResolver);
gsap.registerPlugin(Draggable, InertiaPlugin);

exports.wrapRootElement = ({ element }) => <UIProvider>{element}</UIProvider>;

function onReactIntlError(error) {
  if (error.code === 'MISSING_DATA' && error.message.match('Missing locale data for locale')) {
    // ignore this message, see README
    return;
  }
  console.error(error);
}

exports.wrapPageElement = ({ element, props }) => {
  // default locale
  let locale = 'is';

  // search the data for correct locale
  try {
    const values = Object.values(props.data.prismic);
    let item = null;
    if (values.length > 0) {
      // singular type
      if (values[0].edges && Array.isArray(values[0].edges) && values[0].edges.length > 0) {
        item = values[0].edges[0].node;
        // repeatable
      } else {
        item = values[0];
      }

      if (item && item._meta && item._meta.lang) {
        locale = item._meta.lang;
      }
    }
  } catch (e) {
    // nada
    console.error(e);
  }

  return (
    <IntlProvider onError={onReactIntlError} locale={locale} messages={messages[locale]}>
      {element}
    </IntlProvider>
  );
};

exports.onClientEntry = () => {
  require('intersection-observer');
};

// page transitions
exports.shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  const { state, hash, action } = location;

  if (!state) {
    return;
  }

  // need to return out of this if is article navigation also
  if (hash) return; // don't scroll if its a hash link

  const transitionDuration = state.transition ? 500 : 0;

  if (action === 'PUSH') {
    window.setTimeout(() => window.scrollTo(0, 0), transitionDuration);
  } else {
    const savedPosition = getSavedScrollPosition(location);
    window.setTimeout(() => window.scrollTo(...(savedPosition || [0, 0])), transitionDuration);
  }
  return false;
};
